import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'corner-up-right', 'CornerUpRight', [["path",{"d":"M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4","key":"svg-0"}]]);